import { render, staticRenderFns } from "./IconPlusSmOutline.vue?vue&type=template&id=48948555"
import script from "./IconPlusSmOutline.vue?vue&type=script&lang=js"
export * from "./IconPlusSmOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports